import React from "react";

function Admissions_Home() {
  return (
    <div className="box admissions-box">
      <div className="wh">
        <h1 className="heading">Admissions</h1>
        <div className="bullet-text">
           <div className="bullet-item">
            <span className="bold-text">
          Applications closed for July-2026 Session
          </span>{" "}     
          </div>
        </div>
      </div>
    </div>
  );
}

export default Admissions_Home;
